import {Elm} from './elm/MetaUserImpersonationSelection.elm'

function initMetaUserImpersonationSelection(context, flags) {
  Elm.MetaUserImpersonationSelection.init({
    node: context,
    flags: flags
  });
}

export {initMetaUserImpersonationSelection}